import React, { useEffect, useState } from 'react';
import { AccessTime, AddCircle } from '@material-ui/icons';
import { Button, Paper, Container, Drawer } from '@material-ui/core';
import { useSelector } from 'react-redux';
import {
  CREATE_ACTIVITY,
  STATUS_SUB_CATEGORY_LIST,
  AVAILABILITY_SUB_CATEGORY_LIST,
  LOCATION_SUB_CATEGORY_LIST,
  PRICE_SUB_CATEGORY_LIST,
  ACTIVITY_CALENDAR_TYPE_CATEGORY,
  ACTIVITY_CALENDAR_CATEGORY_VIEW,
  ACTIVITY_CALENDAR_TYPE_ACTIVITIES,
  ACTIVITY_CALENDAR_CATEGORY_CREATE,
  ACTIVITY_CALENDAR_CATEGORY_EDIT,
  ACTIVITY_FILTER_LIST,
  FILTER_TYPE_TAG,
  FILTER_TYPE_STATUS,
  FILTER_TYPE_AVAILABILITY,
  FILTER_TYPE_LOCATION,
  FILTER_TYPE_CATEGORY,
  FILTER_TYPE_PRICE,
  AVAILABILITY_RESIDENTS_ONLY,
  AVAILABILITY_OPEN_TO_ALL,
  STATUS_MAPPING,
} from '../../../../constants/ActivityCalendarConst';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import ActivityCalendar from './activity-calendar';
import ActivityDatePicker from './activity-date-picker';
import ActivityToggle from './activity-toggle';
import { selectedHotelSelector } from '../../../property/propertySlice';
import ActivityCalendarCategoryList from '../activity-calendar-categories/activity-calendar-category-list/Activity-Calendar-Category-List';
import ActivityCalendarCategoryCreate from '../activity-calendar-categories/activity-calendar-category-create/Activity-Calendar-Category-Create';
import ActivityCalendarListView from '../activity-view/ActivityCalendarListView';
import ActivityFilter from '../activity-filter/activityFilter';
import { CALENDAR } from '../../../../utils/Constants';
import ActivityKebabMenu from '../activity-common-file/activity-kebab-menu';
import { allActivityCalendarCategoriesSelector, offerLoaderSelector } from '../../cmsSlice';
import ActivityCalendarCategoryView from '../activity-calendar-categories/activity-calendar-category-view/Activity-Calendar-Category-View';
import { CITY_GUIDE_CATEGORY_CREATE } from '../../../../constants/CityGuideConst';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const ActivityCalendarList = ({
  permissions,
  showLoader = () => {},
  setDrawerContentType,
  setDrawerIsOpen,
  handleView,
  handleEdit,
  handleDelete,
  handleDeactivate,
  viewMode,
  setViewMode,
  listTab,
  setListTab,
  activitiesList,
  setActivitiesList,
  calendarView,
  setCalendarView,
   selectedDate,
  setSelectedDate,
  dateRange,
  setDateRange,
}) => {
  const classes = useStyles();
  const activityList = useSelector(({ cms }) => cms?.activityList);
  const activityType = useSelector(({ cms }) => cms?.activityTagsList);
  const location = useSelector(({ property }) => property?.allLocations);
  const selectedHotel = useSelector(selectedHotelSelector);
  const [isShowMenu, setIsShowMenu] = useState('');
  const [showFilter, setShowFilter] = useState(false);
  const [subFilterAnchorEl, setSubFilterAnchorEl] = useState(null);
  const [anchorEl, setAnchorEl] = useState('');
  const [activityTypeList, setActivityTypeList] = useState([...activityType]);
  const getActivityCategoriesList = useSelector(allActivityCalendarCategoriesSelector);
  const [showActiveFilterName, setActiveFilterName] = useState({
    name: '',
    id: '',
  });
  const loader = useSelector(offerLoaderSelector);
  const [state, setState] = useState({
    type: CITY_GUIDE_CATEGORY_CREATE,
    status: false,
  });
  const activeTab = listTab;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [viewState, setViewState] = useState({
    type: ACTIVITY_CALENDAR_CATEGORY_VIEW,
    status: false,
    obj: null,
  });
  const [statusSubCategoryList, setStatusCategoryList] = useState([...STATUS_SUB_CATEGORY_LIST]);
  const [availability, setAvailability] = useState([...AVAILABILITY_SUB_CATEGORY_LIST]);
  const [locationList, setLocationList] = useState([...LOCATION_SUB_CATEGORY_LIST]);
  const [categoryList, setCategoryList] = useState(getActivityCategoriesList || []);
  const [suppressViewClick, setSuppressViewClick] = useState(false);

  const [priceList, setPriceList] = useState([...PRICE_SUB_CATEGORY_LIST]);
  const dayOrder = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

  const onDrawerToggle = (type, status, obj) => {
    setDrawerState({ type, status, obj });
  };

  const countCheckedItems = (items) => {
    return items?.filter((item) => item?.isChecked)?.length || 0;
  };

  const filterOptions = [
    {
      id: '2',
      options: categoryList,
      setOptions: setCategoryList,
      filterKey: FILTER_TYPE_CATEGORY,
      isShowAll: false,
      isShowAllSearch: false,
      selectedCount: countCheckedItems(categoryList),
    },
    {
      id: '3',
      options: statusSubCategoryList,
      setOptions: setStatusCategoryList,
      filterKey: FILTER_TYPE_STATUS,
      isShowAll: false,
      isShowAllSearch: false,
      selectedCount: countCheckedItems(statusSubCategoryList),
    },
    {
      id: '4',
      options: locationList,
      setOptions: setLocationList,
      filterKey: FILTER_TYPE_LOCATION,
      isShowAll: false,
      isShowAllSearch: false,
      selectedCount: countCheckedItems(locationList),
    },
    {
      id: '5',
      options: availability,
      setOptions: setAvailability,
      filterKey: FILTER_TYPE_AVAILABILITY,
      isShowAll: false,
      isShowAllSearch: false,
      selectedCount: countCheckedItems(availability),
    },
    {
      id: '6',
      options: priceList,
      setOptions: setPriceList,
      filterKey: FILTER_TYPE_PRICE,
      isShowAll: false,
      isShowAllSearch: false,
      selectedCount: countCheckedItems(priceList),
    },
    {
      id: '7',
      options: activityTypeList,
      setOptions: setActivityTypeList,
      filterKey: FILTER_TYPE_TAG,
      isShowAll: true,
      isShowAllSearch: true,
      selectedCount: countCheckedItems(activityTypeList),
    },
  ];

  const totalSelectedFilters = filterOptions?.reduce((total, filter) => {
    return total + filter?.selectedCount;
  }, 0);

  const onViewToggle = (type, status, obj) => {
    setViewState({ type, status, obj });
  };

  const [drawerState, setDrawerState] = useState({
    type: ACTIVITY_CALENDAR_CATEGORY_CREATE,
    status: false,
    obj: null,
  });

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setDrawerState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case ACTIVITY_CALENDAR_CATEGORY_CREATE:
        return (
          <ActivityCalendarCategoryCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            loader={loader}
            showLoader={showLoader}
          />
        );
      case ACTIVITY_CALENDAR_CATEGORY_EDIT:
        return (
          <ActivityCalendarCategoryCreate
            toggleDrawer={onDrawerToggle}
            category={state?.obj}
            hotelId={selectedHotel}
            loader={loader}
            showLoader={showLoader}
          />
        );
      default:
        return null;
    }
  };

  const switchViewContent = (viewState) => {
    switch (viewState.type) {
      case ACTIVITY_CALENDAR_CATEGORY_VIEW:
        return (
          <ActivityCalendarCategoryView
            activityCalendarCategory={viewState?.obj}
            onViewToggle={onViewToggle}
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            permissions={permissions}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (dateRange?.startDate && dateRange?.endDate && activityList?.length) {
      const rangeStart = moment(dateRange?.startDate).startOf('day');
      const rangeEnd = moment(dateRange?.endDate).endOf('day');

      const filteredActivities = activityList.filter((activity) => {
        if (activity?.schedule?.alwaysActive) return true;

        const schedule = activity?.schedule;
        if (!schedule) return true;
        const type = schedule?.scheduleType;
        if (!type) return true;

        if (type === 'ONE_TIME') {
          if (!schedule?.oneTime?.date) return true;
          const activityDate = moment(schedule?.oneTime?.date, 'DD-MM-YYYY').startOf('day');
          if (!activityDate.isValid()) return true;
          return activityDate.isBetween(rangeStart, rangeEnd, 'day', '[]');
        }

        if (type === 'RECURRING') {
          const activityStartDate = moment(schedule?.recurring?.startDate, 'DD-MM-YYYY').startOf('day');
          const activityEndDate = moment(schedule?.recurring?.endDate, 'DD-MM-YYYY').endOf('day');
          
          if (!activityStartDate.isValid() || !activityEndDate.isValid()) return true;
          
          const hasOverlap = !(activityEndDate.isBefore(rangeStart) || activityStartDate.isAfter(rangeEnd));
          if (!hasOverlap) {
            return false;
          }
          
          const recurs = schedule?.recurring?.recurs;
          if (!recurs) return true;
          
          if (recurs === 'DAY') {
            return true;
          }
          
          if (recurs === 'WEEK') {
            const recursWeek = schedule?.recurring?.recursWeek || [];
            if (!recursWeek.length) return true;
            
            const effectiveStart = moment.max(activityStartDate, rangeStart);
            const effectiveEnd = moment.min(activityEndDate, rangeEnd);
            
            let currentDate = effectiveStart.clone();
            while (currentDate.isSameOrBefore(effectiveEnd)) {
              const dayName = currentDate.format('dddd').toUpperCase();
              if (recursWeek.includes(dayName)) {
                return true;
              }
              currentDate.add(1, 'day');
            }
            return false;
          }
          
          if (recurs === 'MONTH') {
            const dates = schedule?.recurring?.dates?.[0]?.split(',') || [];
            if (!dates.length || !dates[0]) return true;
            
            const effectiveStart = moment.max(activityStartDate, rangeStart);
            const effectiveEnd = moment.min(activityEndDate, rangeEnd);
            
            let currentDate = effectiveStart.clone();
            while (currentDate.isSameOrBefore(effectiveEnd)) {
              if (dates.includes(currentDate.format('D'))) {
                return true;
              }
              currentDate.add(1, 'day');
            }
            return false;
          }
          
          return true;
        }

        return true;
      });

      setActivitiesList(filteredActivities);
    } else {
      setActivitiesList([...activityList]);
    }
  }, [dateRange, activityList, viewMode]);

  const handleResetlist = React.useCallback(() => {
    setActivityTypeList([...activityType]);

    if (dateRange?.startDate && dateRange?.endDate && activityList?.length) {
      const rangeStart = moment(dateRange?.startDate).startOf('day');
      const rangeEnd = moment(dateRange?.endDate).endOf('day');

      const filteredActivities = activityList.filter((activity) => {
        if (activity?.schedule?.alwaysActive) return true;

        const schedule = activity?.schedule;
        if (!schedule) return true;
        const type = schedule?.scheduleType;
        if (!type) return true;

        if (type === 'ONE_TIME') {
          if (!schedule?.oneTime?.date) return true;
          const activityDate = moment(schedule?.oneTime?.date, 'DD-MM-YYYY').startOf('day');
          if (!activityDate.isValid()) return true;
          return activityDate.isBetween(rangeStart, rangeEnd, 'day', '[]');
        }

        if (type === 'RECURRING') {
          const activityStartDate = moment(schedule?.recurring?.startDate, 'DD-MM-YYYY').startOf('day');
          const activityEndDate = moment(schedule?.recurring?.endDate, 'DD-MM-YYYY').endOf('day');
          
          if (!activityStartDate.isValid() || !activityEndDate.isValid()) return true;
          
          const hasOverlap = !(activityEndDate.isBefore(rangeStart) || activityStartDate.isAfter(rangeEnd));
          if (!hasOverlap) {
            return false;
          }
          
          const recurs = schedule?.recurring?.recurs;
          if (!recurs) return true;
          
          if (recurs === 'DAY') {
            return true;
          }
          
          if (recurs === 'WEEK') {
            const recursWeek = schedule?.recurring?.recursWeek || [];
            if (!recursWeek.length) return true;
            
            const effectiveStart = moment.max(activityStartDate, rangeStart);
            const effectiveEnd = moment.min(activityEndDate, rangeEnd);
            
            let currentDate = effectiveStart.clone();
            while (currentDate.isSameOrBefore(effectiveEnd)) {
              const dayName = currentDate.format('dddd').toUpperCase();
              if (recursWeek.includes(dayName)) {
                return true;
              }
              currentDate.add(1, 'day');
            }
            return false;
          }
          
          if (recurs === 'MONTH') {
            const dates = schedule?.recurring?.dates?.[0]?.split(',') || [];
            if (!dates.length || !dates[0]) return true;
            
            const effectiveStart = moment.max(activityStartDate, rangeStart);
            const effectiveEnd = moment.min(activityEndDate, rangeEnd);
            
            let currentDate = effectiveStart.clone();
            while (currentDate.isSameOrBefore(effectiveEnd)) {
              if (dates.includes(currentDate.format('D'))) {
                return true;
              }
              currentDate.add(1, 'day');
            }
            return false;
          }
          
          return true;
        }

        return true;
      });

      setActivitiesList(filteredActivities);
    } else {
      setActivitiesList([...activityList]);
    }
    setStatusCategoryList([...STATUS_SUB_CATEGORY_LIST]);
    setAvailability([...AVAILABILITY_SUB_CATEGORY_LIST]);
    setLocationList([...LOCATION_SUB_CATEGORY_LIST]);
    setPriceList([...PRICE_SUB_CATEGORY_LIST]);
    setCategoryList([...getActivityCategoriesList]);
  }, [activityType, activityList, getActivityCategoriesList, dateRange]);

  useEffect(() => {
    handleResetlist();
  }, [handleResetlist, viewMode]);

  useEffect(() => {
    if (selectedHotel && viewState?.status) {
      setViewState({
        type: '',
        status: false,
        obj: null,
      });
    }
  }, [selectedHotel]);

  useEffect(() => {
    if (
      activeTab === ACTIVITY_CALENDAR_TYPE_CATEGORY ||
      activeTab === ACTIVITY_CALENDAR_TYPE_ACTIVITIES
    ) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  const handleShowFilter = (event) => {
    if (showActiveFilterName?.name) {
      setActiveFilterName({ name: '', id: '' });
      setAnchorEl('');
    } else {
      setShowFilter(!showFilter);
      setAnchorEl(event?.currentTarget);
    }
  };

  const handleSelectFilter = (event, index) => {
    const selectedFilter = ACTIVITY_FILTER_LIST[index];
    setActiveFilterName(selectedFilter);
    setSubFilterAnchorEl(event);
    if (selectedFilter?.id === '1') {
      handleResetlist();
    }
  };

  const handleClose = (value) => {
    if (!value) {
      setShowFilter(false);
    }
  };

  const handleFilterResult = (type, filterValue) => {
    if (!activityList || !Array.isArray(activityList)) return;

    const rangeStart = moment(dateRange?.startDate).startOf('day');
    const rangeEnd = moment(dateRange?.endDate).endOf('day');

    let result = activityList.filter((activity) => {
      if (activity?.schedule?.alwaysActive) return true;

      const schedule = activity?.schedule;
      if (!schedule) return true;
      const scheduleType = schedule?.scheduleType;
      if (!scheduleType) return true;

      if (scheduleType === 'ONE_TIME') {
        if (!schedule?.oneTime?.date) return true;
        const activityDate = moment(schedule?.oneTime?.date, 'DD-MM-YYYY').startOf('day');
        if (!activityDate.isValid()) return true;
        return activityDate.isBetween(rangeStart, rangeEnd, 'day', '[]');
      }

      if (scheduleType === 'RECURRING') {
        const activityStartDate = moment(schedule?.recurring?.startDate, 'DD-MM-YYYY').startOf('day');
        const activityEndDate = moment(schedule?.recurring?.endDate, 'DD-MM-YYYY').endOf('day');
        
        if (!activityStartDate.isValid() || !activityEndDate.isValid()) return true;
        
        const hasOverlap = !(activityEndDate.isBefore(rangeStart) || activityStartDate.isAfter(rangeEnd));
        if (!hasOverlap) {
          return false;
        }
        
        const recurs = schedule?.recurring?.recurs;
        if (!recurs) return true;
        
        if (recurs === 'DAY') {
          return true;
        }
        
        if (recurs === 'WEEK') {
          const recursWeek = schedule?.recurring?.recursWeek || [];
          if (!recursWeek.length) return true;
          
          const effectiveStart = moment.max(activityStartDate, rangeStart);
          const effectiveEnd = moment.min(activityEndDate, rangeEnd);
          
          let currentDate = effectiveStart.clone();
          while (currentDate.isSameOrBefore(effectiveEnd)) {
            const dayName = currentDate.format('dddd').toUpperCase();
            if (recursWeek.includes(dayName)) {
              return true;
            }
            currentDate.add(1, 'day');
          }
          return false;
        }
        
        if (recurs === 'MONTH') {
          const dates = schedule?.recurring?.dates?.[0]?.split(',') || [];
          if (!dates.length || !dates[0]) return true;
          
          const effectiveStart = moment.max(activityStartDate, rangeStart);
          const effectiveEnd = moment.min(activityEndDate, rangeEnd);
          
          let currentDate = effectiveStart.clone();
          while (currentDate.isSameOrBefore(effectiveEnd)) {
            if (dates.includes(currentDate.format('D'))) {
              return true;
            }
            currentDate.add(1, 'day');
          }
          return false;
        }
        
        return true;
      }

      return true;
    });

    const tagList = type === FILTER_TYPE_TAG ? filterValue : activityTypeList;
    const status = type === FILTER_TYPE_STATUS ? filterValue : statusSubCategoryList;
    const availabilityData = type === FILTER_TYPE_AVAILABILITY ? filterValue : availability;
    const locationData = type === FILTER_TYPE_LOCATION ? filterValue : locationList;
    const price = type === FILTER_TYPE_PRICE ? filterValue : priceList;
    const categoryData = type === FILTER_TYPE_CATEGORY ? filterValue : categoryList;

    const selectedCategories = categoryData
      ?.filter((category) => category?.isChecked)
      ?.map((category) => category?.id);

    const selectedTag = tagList?.filter((activity) => activity?.isChecked)?.map((tag) => tag?.id);

    const statusList = status?.filter((activity) => activity?.isChecked)?.map((tag) => tag?.label);
    if (selectedCategories?.length) {
      result = result.filter((activity) => selectedCategories?.includes(activity?.categoryId));
    }
    if (selectedTag?.length) {
      result = result.filter((activity) =>
        selectedTag?.some((tagId) => activity?.tags?.includes(tagId)),
      );
    }
    const availabilityList = availabilityData
      ?.filter((activity) => activity?.isChecked)
      ?.map((availability) => availability?.id);

    const selectedLocations = locationData?.filter((loc) => loc?.isChecked)?.map((loc) => loc?.id);

    const selectedPrice = price
      ?.filter((activity) => activity?.isChecked)
      ?.map((activity) => activity?.id);

    if (availabilityList?.length) {
      result = result?.filter((activity) => {
        if (
          availabilityList?.includes(AVAILABILITY_RESIDENTS_ONLY) &&
          availabilityList?.includes(AVAILABILITY_OPEN_TO_ALL)
        ) {
          return true;
        }
        if (availabilityList?.includes(AVAILABILITY_RESIDENTS_ONLY)) {
          return activity?.residentsOnly === true;
        }
        if (availabilityList?.includes(AVAILABILITY_OPEN_TO_ALL)) {
          return activity?.residentsOnly === false;
        }
        return false;
      });
    }
    if (selectedCategories?.length) {
      result = result?.filter((activity) => selectedCategories?.includes(activity?.categoryId));
    }

    if (selectedTag?.length) {
      result = result?.filter((activity) =>
        selectedTag?.some((tagId) => activity?.tags?.includes(tagId)),
      );
    }

    if (statusList?.length) {
      result = result?.filter((activity) =>
        statusList?.some((status) => activity?.isActive === STATUS_MAPPING[status]),
      );
    }

    if (selectedLocations?.length) {
      result = result?.filter(
        (activity) =>
          activity?.activityLocation &&
          selectedLocations?.includes(activity?.activityLocation?.locationType),
      );
    }
    if (selectedPrice?.length) {
      result = result?.filter((activity) => {
        const isFree = !activity?.price || activity?.price === 0 || activity?.price === null;
        const isPaid = activity?.price > 0;

        if (selectedPrice?.includes('free') && selectedPrice?.includes('paid')) {
          return true;
        } else if (selectedPrice?.includes('free')) {
          return isFree;
        } else if (selectedPrice?.includes('paid')) {
          return isPaid;
        }
        return true;
      });
    }

    setActivitiesList([...result]);
  };

  const handleActions = (value, actionType) => {
    if (actionType === 'Edit') {
      handleEdit(value);
    } else if (actionType === 'View') {
      handleView(value);
    } else if (actionType === 'Deactivate') {
      handleDeactivate(value?.id, value?.isActive);
    } else {
      handleDelete(value);
    }
    setIsShowMenu({ anchorEl: '', id: '' });
  };
  const getUpcomingTimeSlot = (timeSlots) => {
    if (!timeSlots?.length) return null;

    const currentTime = moment();
    const today = moment()?.format('YYYY-MM-DD');

    const sortedSlots = [...timeSlots]?.sort((a, b) => {
      const timeA = moment(`${today} ${a.startTime}`, 'YYYY-MM-DD HH:mm');
      const timeB = moment(`${today} ${b.startTime}`, 'YYYY-MM-DD HH:mm');
      return timeA - timeB;
    });

    const upcomingSlot =
      sortedSlots?.find((slot) => {
        const slotTime = moment(`${today} ${slot?.startTime}`, 'YYYY-MM-DD HH:mm');
        return slotTime?.isAfter(currentTime);
      }) || sortedSlots[0];

    return {
      slot: upcomingSlot,
      remainingCount: timeSlots?.length - 1,
    };
  };

  const computeNextRecurringDate = (recurringRule) => {
    const today = moment().startOf('day');
    if (!recurringRule) return today;
    const startDay = moment(recurringRule?.startDate, 'DD-MM-YYYY')?.startOf('day');
    const endDay = moment(recurringRule?.endDate, 'DD-MM-YYYY')?.endOf('day');
    if (!startDay.isValid() || !endDay.isValid()) return today;
    const { recurs, recursWeek = [], dates = [] } = recurringRule;

    if (today?.isAfter(endDay, 'day')) return endDay;
    if (today?.isBefore(startDay, 'day')) return startDay;

    if (recurs === 'DAY') {
      return today;
    }

    if (recurs === 'WEEK') {
      const weekdayIndexes = recursWeek?.map((d) => dayOrder?.indexOf(d));
      for (let i = 0; i < 7; i++) {
        const candidate = today?.clone()?.add(i, 'days');
        if (weekdayIndexes?.includes(candidate?.day())) {
          return candidate;
        }
      }
    }

    if (recurs === 'MONTH') {
      const dayNums = dates
        ?.flatMap((d) =>
          typeof d === 'string' && d.includes(',')
            ? d.split(',').map((v) => parseInt(v.trim(), 10))
            : [parseInt(d, 10)],
        )
        ?.filter((n) => !isNaN(n))
        ?.sort((a, b) => a - b);
      const todayNum = today?.date();
      for (let num of dayNums) {
        if (num >= todayNum) {
          return today?.clone()?.date(num);
        }
      }
      return today?.clone()?.add(1, 'month')?.date(dayNums[0]);
    }

    return today;
  };

  const computeActivityNextMoment = (activity) => {
    const { schedule } = activity;

    if (schedule?.alwaysActive) {
      return moment(0);
    }

    if (schedule?.scheduleType === 'ONE_TIME') {
      return moment(`${schedule?.oneTime?.date} ${schedule?.startTime}`, 'DD-MM-YYYY HH:mm');
    }

    if (schedule?.scheduleType === 'RECURRING') {
      const nextDate = computeNextRecurringDate(schedule?.recurring);

      if (schedule?.recurring?.totalActivityTime) {
        return moment(
          `${nextDate?.format('DD-MM-YYYY')} ${schedule?.startTime}`,
          'DD-MM-YYYY HH:mm',
        );
      }

      const nextSlot = getUpcomingTimeSlot(schedule?.recurring?.recurringTimeSlots)?.slot;
      return moment(`${nextDate?.format('DD-MM-YYYY')} ${nextSlot?.startTime}`, 'DD-MM-YYYY HH:mm');
    }

    return moment(0);
  };

  const sortActivities = (activities) =>
    activities?.sort((firstAct, secondAct) => {
      if (firstAct?.schedule?.alwaysActive && !secondAct?.schedule?.alwaysActive) return -1;
      if (!firstAct?.schedule?.alwaysActive && secondAct?.schedule?.alwaysActive) return 1;

      const today = moment().startOf('day');
      const startA = computeActivityNextMoment(firstAct);
      const startB = computeActivityNextMoment(secondAct);

      const classify = (m) => (m?.isSame(today, 'day') ? 0 : m.isAfter(today, 'day') ? 1 : 2);

      const bucketA = classify(startA);
      const bucketB = classify(startB);
      if (bucketA !== bucketB) return bucketA - bucketB;

      if (bucketA === 2) {
        return startB?.diff(startA);
      } else {
        return startA?.diff(startB);
      }
    });

  return (
    <>
      <Drawer
        anchor='right'
        open={drawerState.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(drawerState)}
      </Drawer>

      {viewState.status ? (
        <>{switchViewContent(viewState)}</>
      ) : (
        <Container className='mt-4'>
          <div className='row d-flex flex-wrap gap-3 justify-content-between align-items-center m-auto'>
            <div className='col'>
              <span className='page-title'>Activities</span>
            </div>
            <div className='row d-flex mt-4 activity-list'>
              <div className='d-flex flex-wrap'>
                <Button
                  size='large'
                  variant={activeTab === ACTIVITY_CALENDAR_TYPE_CATEGORY ? 'outlined' : 'text'}
                  className={
                    activeTab === ACTIVITY_CALENDAR_TYPE_CATEGORY
                      ? classes.activeButton
                      : classes.button + 'showpopup'
                  }
                  onClick={() => {
                    setListTab(ACTIVITY_CALENDAR_TYPE_CATEGORY);
                    handleResetlist();
                  }}
                >
                  Category
                </Button>
                <Button
                  size='large'
                  variant={activeTab === ACTIVITY_CALENDAR_TYPE_ACTIVITIES ? 'outlined' : 'text'}
                  className={
                    activeTab === ACTIVITY_CALENDAR_TYPE_ACTIVITIES
                      ? classes.activeButton
                      : classes.button + 'showpopup'
                  }
                  onClick={() => setListTab(ACTIVITY_CALENDAR_TYPE_ACTIVITIES)}
                >
                  Activities
                </Button>
                {activeTab === ACTIVITY_CALENDAR_TYPE_ACTIVITIES && (
                  <div className='col d-flex justify-content-end align-items-center gap-2'>
                    <ActivityToggle viewMode={viewMode} setViewMode={setViewMode} />
                    <ActivityDatePicker
                      dateRange={dateRange}
                      setDateRange={setDateRange}
                    />
                    <Button
                      variant='contained'
                      color='primary'
                      size='large'
                      startIcon={<AddCircle />}
                      onClick={() => {
                        setDrawerContentType(CREATE_ACTIVITY);
                        setDrawerIsOpen(true);
                      }}
                    >
                      Add Activity
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {activeTab === ACTIVITY_CALENDAR_TYPE_CATEGORY && (
            <div className='row mx-2 d-flex mt-4'>
              <ActivityCalendarCategoryList
                permissions={permissions}
                onDrawerToggle={onDrawerToggle}
                onViewToggle={onViewToggle}
                selectedHotel={selectedHotel}
                state={state}
                onsetPage={(e) => setPage(e)}
                page={page}
                onsetRowsPerPage={(e) => setRowsPerPage(e)}
                rowsPerPage={rowsPerPage}
              />
            </div>
          )}

          {activeTab === ACTIVITY_CALENDAR_TYPE_ACTIVITIES && (
            <div className='row d-flex mt-4'>
              {viewMode === CALENDAR ? (
                <div className='card shadow'>
                  <div className='activityCalenderView'>
                    <div className='col-12 flex-wrap d-flex mt-4 mb-4 h-100'>
                      <div className='col-12 col-lg-5 h-100 mb-4 mb-lg-0 activity-list-column'>
                        <div className='d-flex mb-2 justify-content-between align-items-center '>
                          <ActivityFilter
                            showFilter={showFilter}
                            filterOptions={filterOptions}
                            setShowFilter={setShowFilter}
                            anchorEl={anchorEl}
                            setAnchorEl={setAnchorEl}
                            activityTypeList={activityTypeList}
                            setActivityTypeList={setActivityTypeList}
                            statusSubCategoryList={statusSubCategoryList}
                            setStatusCategoryList={setStatusCategoryList}
                            availability={availability}
                            setAvailability={setAvailability}
                            handleFilterResult={handleFilterResult}
                            locationList={locationList}
                            setLocationList={setLocationList}
                            priceList={priceList}
                            setPriceList={setPriceList}
                            categoryList={categoryList}
                            setCategoryList={setCategoryList}
                            setActiveFilterName={setActiveFilterName}
                            showActiveFilterName={showActiveFilterName}
                            handleResetlist={handleResetlist}
                            isCalendarview='true'
                            handleClose={handleClose}
                            handleShowFilter={handleShowFilter}
                            handleSelectFilter={handleSelectFilter}
                            subFilterAnchorEl={subFilterAnchorEl}
                          />
                          <div className='activityCount'>
                            {activitiesList?.length < 2
                              ? `${activitiesList?.length} activity`
                              : `${activitiesList?.length} activities`}
                          </div>
                        </div>
                        <div className='activityListStyle p-2'>
                          {sortActivities([...activitiesList])?.map((item) => {
                            const startTime = item?.schedule?.startTime;
                            const endTime = item?.schedule?.endTime;
                            const timeSlotInfo = getUpcomingTimeSlot(
                              item?.schedule?.recurring?.recurringTimeSlots,
                            );

                            return (
                              <Paper
                                className='activityCardList'
                                key={item?.id}
                                style={
                                  item?.label
                                    ? {
                                        borderLeft: `9px solid ${item?.label}`,
                                      }
                                    : {}
                                }
                                onClick={() => {
                                  if (suppressViewClick) {
                                    setSuppressViewClick(false);
                                    return;
                                  }
                                  handleActions(item, 'View');
                                }}
                              >
                                <div className='activityCardListTitle col-md-12 pointer'>
                                  <div className='col-md-10'>{item?.name}</div>
                                  <div className='col-md-2'>
                                    <ActivityKebabMenu
                                      activityData={item}
                                      handleActions={handleActions}
                                      setSuppressViewClick={setSuppressViewClick}
                                    />
                                  </div>
                                </div>
                                <div className='d-flex justify-content-between flex-row pt-1 align-items-center'>
                                  {item?.schedule?.alwaysActive ? (
                                    <div>
                                      <span className='activityCardListTime'>Always Active</span>
                                    </div>
                                  ) : item?.schedule?.scheduleType === 'RECURRING' ? (
                                    <div className='activityCardListTime d-flex align-items-center'>
                                      {item?.schedule?.recurring?.totalActivityTime ? (
                                        <span>
                                          {moment(item?.schedule?.startTime, 'HH:mm').format(
                                            'hh:mm A',
                                          )}{' '}
                                          -
                                          {moment(item?.schedule?.endTime, 'HH:mm').format(
                                            'hh:mm A',
                                          )}
                                        </span>
                                      ) : (
                                        timeSlotInfo?.slot && (
                                          <>
                                            <span>
                                              {`${moment(
                                                timeSlotInfo?.slot?.startTime,
                                                'HH:mm',
                                              )?.format('hh:mm A')} - 
                                       ${moment(timeSlotInfo?.slot?.endTime, 'HH:mm')?.format(
                                         'hh:mm A',
                                       )}`}
                                              {timeSlotInfo?.remainingCount > 0 && (
                                                <span>
                                                  {' '}
                                                  |
                                                  <span className='remainingCount'>
                                                    {' '}
                                                    +{timeSlotInfo?.remainingCount}
                                                  </span>
                                                </span>
                                              )}
                                            </span>
                                            {timeSlotInfo?.remainingCount > 0 && (
                                              <AccessTime className='timer' />
                                            )}
                                          </>
                                        )
                                      )}
                                    </div>
                                  ) : (
                                    <div className='activityCardListTime'>
                                      {moment(item?.schedule?.startTime, 'HH:mm').format(
                                        'hh:mm A',
                                      ) ?? ''}{' '}
                                      -{' '}
                                      {moment(item?.schedule?.endTime, 'HH:mm').format('hh:mm A') ??
                                        ''}
                                    </div>
                                  )}
                                  <div
                                    className={`pill d-flex justify-content-center align-items-center ${
                                      item?.isActive ? 'pill-active' : 'pill-inactive'
                                    } min-w-20`}
                                  >
                                    <span className='ms-1'>
                                      {item?.isActive ? 'Active' : 'Inactive'}
                                    </span>
                                  </div>
                                </div>
                                <div className='activityCardListTime'>
                                  <div>
                                    {item?.location
                                      ? location?.find((loc) => loc?.id === item?.location)?.name
                                      : ''}
                                  </div>
                                </div>
                              </Paper>
                            );
                          })}
                        </div>
                      </div>
                      <div className='col-12 col-lg-7 calendar-panel'>
                        <ActivityCalendar
                          eventList={activityList}
                          selectedDate={selectedDate}
                          setSelectedDate={setSelectedDate}
                          location={location}
                          calendarView={calendarView}
                          setCalendarView={setCalendarView}
                          dateRange={dateRange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <ActivityCalendarListView
                  setDrawerIsOpen={setDrawerIsOpen}
                  setDrawerContentType={setDrawerContentType}
                  setActivitiesList={setActivitiesList}
                  activitiesList={activitiesList}
                  sortActivities={sortActivities}
                  selectedDate={selectedDate}
                  handleClose={handleClose}
                  showFilter={showFilter}
                  setShowFilter={setShowFilter}
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                  activityTypeList={activityTypeList}
                  setActivityTypeList={setActivityTypeList}
                  setActiveFilterName={setActiveFilterName}
                  showActiveFilterName={showActiveFilterName}
                  statusSubCategoryList={statusSubCategoryList}
                  setStatusCategoryList={setStatusCategoryList}
                  handleFilterResult={handleFilterResult}
                  handleResetlist={handleResetlist}
                  availability={availability}
                  setAvailability={setAvailability}
                  locationList={locationList}
                  setLocationList={setLocationList}
                  priceList={priceList}
                  setPriceList={setPriceList}
                  isShowMenu={isShowMenu}
                  setIsShowMenu={setIsShowMenu}
                  handleActions={handleActions}
                  categoryList={categoryList}
                  setCategoryList={setCategoryList}
                  filterOptions={filterOptions}
                  totalSelectedFilters={totalSelectedFilters}
                  handleShowFilter={handleShowFilter}
                  handleSelectFilter={handleSelectFilter}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  onsetPage={setPage}
                  onsetRowsPerPage={setRowsPerPage}
                  suppressViewClick={suppressViewClick}
                  setSuppressViewClick={setSuppressViewClick}
                  subFilterAnchorEl={subFilterAnchorEl}
                  hotelId={selectedHotel}
                />
              )}
            </div>
          )}
        </Container>
      )}
    </>
  );
};

export default ActivityCalendarList;
